import { Injectable, signal } from '@angular/core';

@Injectable()
export class CompanyContextService {
  public readonly companyUuid = signal<string>('');
}
